module.exports = __webpack_public_path__ + "static/media/mccarthy.9d083b80.jpg";